// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"40fe6d74","774":"702c3721","787":"96ab61ad"}[chunkId] + ".chunk.js";
};